const paths = {
  landing: '/',
  login: '/login',
  logout: '/logout',
  profile: '/profile',
  not_found: '/404',
  integrations: '/integrations',
  authorization: '/authorization',
  routes: '/routes',
  ml_reports: '/ms-reports',
  reports: '/reports',
  companies: '/companies',
  company_settings: '/company-settings',
  users: '/users',
  indexes: '/indexes',
  beacon: '/beacon',
  ai_logs: '/ai-logs',
  enums: {
    cargo: '/enums/cargo',
    classification_societies: '/enums/classification-societies',
    fuel_grades: '/enums/fuel-grades',
    vessels: '/enums/vessels',
    vessel_situations: '/enums/vessel-situations',
    vessel_prefixes: '/enums/vessel-prefixes',
    vessel_types: '/enums/vessel-types',
    vessel_subtypes: '/enums/vessel-types/subtypes',
    vessel_type_categories: '/enums/vessel-types/categories',
    ports: '/enums/ports',
    ports_map: '/enums/ports/map',
    routing_areas: '/enums/routing-areas',
    widget_types: '/enums/widget-types',
    cp_forms: '/enums/cp-forms',
    airports: '/enums/airports',
    airlines: '/enums/airlines',
    crew_statuses: '/enums/crew-statuses',
    // crew_evaluation_criteria: '/enums/evaluation-criteria',
    // crew_evaluation_criteria_categories: '/enums/evaluation-criteria-categories',
    crew_identifiers: '/enums/identifiers',
    crew_rank: '/enums/crew-ranks',
    units: '/enums/units',
    agent_types: '/enums/agent-types',
    countries: '/enums/countries',
    nationalities: '/enums/nationalities',
    currencies: '/enums/currencies',
    tools: '/enums/tools',
    laytime_events: '/enums/laytime-events',
    ld_terms: '/enums/ld-terms',
    crew_matrices: '/enums/crew-matrices',
    event_types: '/enums/event-types',
    purchasing_groups: '/enums/purchasing-groups',
    purchasing_stores: '/enums/purchasing-stores',
    purchasing_stores_unlinked: '/enums/purchasing-stores-unlinked'
  }
};

export default paths;
